import type {MetlApiBase} from "../../../metl-api/MetlApiBase.ts";
import {ApiAtom} from "../../../common-process/1-metl-connection/MetlConnectionProperties.ts";
import {useAtomValue} from "jotai";
import {type AnalysisOptions, AnalysisOptionsAtom} from "../../2-option-selection/AnalysisOptions.ts";
import {type ActionProgress, type StartAction, useScanActions} from "../util/ctx/useScanActions.tsx";
import {type LogError, type LogMessage, useScanMessages} from "../util/ctx/useScanMessages.tsx";

export interface SharedJobData {
    implementationId: number
    packageName: string
    jobName: string
    revision: number
}

export interface ScanContext {
    options: AnalysisOptions
    api: MetlApiBase
    sharedJobs: Record<number, SharedJobData>
    dataWarehouse?: string
    version?: string
    log: (message: string) => void
    logError: LogError
    startAction: StartAction
    scanErrors: string[]
}

export interface ScanDisplayInfo {
    loggedMessages: LogMessage[]
    activeActions: ActionProgress[]
}

export function useScanContext(): [ScanContext, ScanDisplayInfo] {
    const options = useAtomValue(AnalysisOptionsAtom)
    const api = useAtomValue(ApiAtom)!
    const [loggedMessages, log, logError, errors] = useScanMessages(options)
    const [activeActions, startAction] = useScanActions()
    
    return [
        {
            options,
            sharedJobs: {},
            api,
            log,
            logError,
            startAction,
            scanErrors: errors
        },
        {
            loggedMessages,
            activeActions
        }
    ]
}